import { CategoryV5, DefaultLogger, getWsKeyForTopic, WebsocketClient, WSClientConfigurableOptions, WsKey } from "libs/bybit-api/src";
import { BoardId } from "../model/common";
import { MarketLoggerService, WsRequestLogRow } from "./market-logger.service";
import { cloneDeep } from "lodash-es";

export class BybitWebsocketClient extends WebsocketClient {

  constructor(options: WSClientConfigurableOptions, logger: typeof DefaultLogger, private marketLogger: MarketLoggerService) {
    super(options, logger)

    this.on('open', ({wsKey, event}) => this.logNetworkEvent(wsKey, event, 'client', 'open'))
    this.on('close', ({wsKey, event}) => this.logNetworkEvent(wsKey, event, 'client', 'close'))
    this.on('reconnected', ({wsKey, event}) => this.logNetworkEvent(wsKey, event, 'client', 'reconnect'))
    this.on('authenticated', data => this.logMessageEvent(data, 'auth'))
    this.on('response', data => this.logMessageEvent(data, 'response'))
    this.on('exception', data => this.logMessageEvent(data, 'error'))
    this.on('update', data => this.logMessageEvent(data, 'message'))
  }

  hasSubscription(board: BoardId, topic: string) {
    let result = false
    this.getWsStore().getTopics(getWsKeyForTopic('v5', topic, undefined, board as CategoryV5)).forEach(t => {
      if (t.topic == topic) {
        result = true
      }
    })
    return result
  }

  // Добавляем логирование при отправке сообщения
  public override tryWsSend(wsKey: WsKey, wsMessage: string, throwExceptions?: boolean) {
    // Логироваине исходящих сообщений
    let payload: any
    try {
      payload = JSON.parse(wsMessage)
      payload = this.logFilter(payload)
    } catch {
      payload = undefined
    }

    if (payload) {
      const logRow: WsRequestLogRow = {
        time: Date.now(),
        market: 'bybit',
        type: 'ws',
        wsKey: wsKey,
        side: 'client',
        event: 'request',
        payload: payload,
      }
      this.marketLogger.log(logRow)
    }

    return super.tryWsSend(wsKey, wsMessage, throwExceptions)
  }

  private logFilter(payload: any): any {
    // Если это публичная маркет-дата, то не логируем
    if ('wsKey' in payload && 'topic' in payload && payload.wsKey == 'v5LinearPublic' && payload.topic) {
      return undefined
    }
    // Если пинг-понг, то не логируем
    if ('op' in payload && payload.op == 'ping' || payload.op == 'pong') {
      return undefined
    }
    // Игнорируем потоки, кроме order и execution
    if ('topic' in payload && !['order', 'execution'].includes(payload.topic)) {
      return undefined
    }
    // В сообщении auth вырезаем чувствительные данные
    if (payload.op == 'auth' && payload.args) {
      payload = cloneDeep(payload)
      payload.args = ['<API_KEY>', payload.args[1], '<SIGNATURE>']
    }
    delete payload.wsKey
    delete payload.isWSAPIResponse
    return payload
  }

  private logNetworkEvent(wsKey: WsKey, event: Event, side: WsRequestLogRow['side'], logEventName: WsRequestLogRow['event']) {
    const websoket = event.target as WebSocket
    const logRow: WsRequestLogRow = {
      time: Date.now(),
      market: 'bybit',
      type: 'ws',
      wsKey: wsKey,
      side: side,
      event: logEventName,
      payload: {
        url: websoket.url
      }
    }
    this.marketLogger.log(logRow)
  }

  private logMessageEvent(data: any & {wsKey: WsKey, isWSAPIResponse?: boolean}, logEventName: WsRequestLogRow['event']) {
    const payload = this.logFilter(data)
    if (payload) {
      const logRow: WsRequestLogRow = {
        time: Date.now(),
        market: 'bybit',
        type: 'ws',
        wsKey: data.wsKey,
        side: 'server',
        event: logEventName,
        payload: payload,
      }
      if ('success' in payload) {
        logRow.apiCode = payload.success ? 0 : -1
      }
      if ('ret_code' in payload) {
        logRow.apiCode = payload.ret_code
      }
      if ('retCode' in payload) {
        logRow.apiCode = payload.retCode
      }
      if ('ret_msg' in payload) {
        logRow.apiMessage = payload.ret_msg
      }
      if ('retMsg' in payload) {
        logRow.apiMessage = payload.retMsg
      }
      this.marketLogger.log(logRow)
    }
  }

}
